export default function titreMessageErreur(isNew, messagesErreur) {
  if (isNew && messagesErreur.length === 1
    && (messagesErreur[0].message === 'general.emailFormatError'
    || messagesErreur[0].message === 'editionContact.messages.customerNameNotExist')) {
    return 'messages.errorCreation2';
  }
  if (!isNew && messagesErreur.length === 1
    && (messagesErreur[0].message === 'general.emailFormatError'
    || messagesErreur[0].message === 'editionContact.messages.customerNameNotExist')) {
    return 'messages.errorChange2';
  }
  if (isNew) {
    return 'messages.errorCreation';
  }
  return 'messages.errorChange';
}
